import { cn } from '@/app/utils/cn'
import { ArrowLeft2 } from 'iconsax-react'
import { useNavigate } from 'react-router-dom'

interface ButtonBackProps {
  label?: string
  action?: () => void
  className?: string
}
export default function ButtonBack({
  label,
  action,
  className,
}: ButtonBackProps) {
  const navigate = useNavigate()
  return (
    <div
      className={cn('mb-8 flex items-center gap-2', className)}
      onClick={action || (() => navigate(-1))}
    >
      <div className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border-[1px] border-[#F0F0F0]">
        <ArrowLeft2 size="24" />
      </div>
      {label && <h1 className="text-2xl font-semibold">{label}</h1>}
    </div>
  )
}
